module.exports = __webpack_public_path__ + "c5ebe0b32dc1b5cc449a76c4204d13bb.ttf";


//////////////////
// WEBPACK FOOTER
// ./node_modules/semantic-ui-css/themes/default/assets/fonts/brand-icons.ttf
// module id = 260
// module chunks = 4